module.exports = __webpack_public_path__ + "static/media/1.1.1607f4bd.png";